@use "ui/styles/colorsOld";

.wrapper {
  cursor: pointer;

  width: fit-content;

  label {
    line-height: 1.1;
    display: grid;
    grid-template-columns: 0.85em auto;
    gap: 0.5em;
    cursor: pointer;

    &[aria-disabled="true"] {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }

  label:focus-within {
    color: colorsOld.$sapphireLight;
  }

  input[type="radio"] {
    color: colorsOld.$sapphireLight;
    -webkit-appearance: none;
    appearance: none;
    background-color: colorsOld.$white;
    margin-top: 1px;
    font: inherit;
    width: 1em;
    height: 1em;
    border: 0.15em solid colorsOld.$sapphireLight;
    border-radius: 50%;
    display: grid;
    place-content: center;
    cursor: pointer;
  }

  input[type="radio"]:disabled {
    box-shadow: inset 1em 1em colorsOld.$stoneLightX4;
    cursor: not-allowed;
    border: 1px solid colorsOld.$stoneLight;
  }

  input[type="radio"]::before {
    content: "";
    width: 0.5em;
    height: 0.5em;
    border-radius: 50%;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em currentColor;
  }

  input[type="radio"]:checked::before {
    transform: scale(1);
  }
}
